import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection2 = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);

  // Dégradé Premium unifié pour l'overlay des images
  const premiumOverlay = "linear-gradient(to top, rgba(10, 10, 10, 0.95) 0%, rgba(26, 26, 26, 0.4) 50%, transparent 100%)";

  const services = [
    {
      title: "Droit des sociétés",
      image: "/images/service1.jpeg",
      description: "Nous aidons les entreprises à structurer leur croissance, respecter la loi et éviter des litiges coûteux et imprévus.",
      keywords: ["Gouvernance", "Fusions", "Restructuration"],
      lien: "/Services-Infos/Services1",
      icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      title: "Expertise Corporative",
      image: "/images/service2.jpg",
      description: "Nos juristes optimisent votre structure d'entreprise pour garantir conformité, performance et protection face aux risques économiques.",
      keywords: ["Audit", "Conformité", "Stratégie"],
      lien: "/Services-Infos/Services2",
      icon: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      title: "Droit financier",
      image: "/images/service3.jpg",
      description: "Conseil et représentation pour la structuration de vos financements et la gestion des contentieux bancaires.",
      keywords: ["Banque", "Investissement", "Contentieux"],
      lien: "/Services-Infos/Services3",
      icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      title: "Droit minier",
      image: "/images/service4.jpg",
      description: "Expertise dans l'encadrement juridique des activités minières : permis, fiscalité, responsabilité environnementale et négociation.",
      keywords: ["Permis", "Fiscalité", "Exploitation"],
      lien: "/Services-Infos/Services4",
      icon: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
    },
    {
      title: "Droit de l'environnement",
      image: "/images/service5.jpg",
      description: "Conseil en droit environnemental et obligations légales liées à l'exploitation des ressources naturelles.",
      keywords: ["Environnement", "Ressources", "Conformité"],
      lien: "/Services-Infos/Services5",
      icon: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      title: "Droit des assurances",
      image: "/images/service6.jpg",
      description: "Gestion rigoureuse des contrats d'assurance et appui juridique lors de sinistres ou litiges.",
      keywords: ["Sinistres", "Couverture", "Responsabilité"],
      lien: "/Services-Infos/Services6",
      icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
    },
    {
      title: "Contentieux civil",
      image: "/images/service7.jpg",
      description: "Défense de vos intérêts devant les juridictions civiles et commerciales pour tous types de litiges.",
      keywords: ["Procès", "Défense", "Médiation"],
      lien: "/Services-Infos/Services7",
      icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    },
    {
      title: "RSE & Compliance",
      image: "/images/service8.jpg",
      description: "Accompagnement en responsabilité sociale pour conjuguer éthique, conformité et développement durable.",
      keywords: ["Éthique", "RSE", "Durabilité"],
      lien: "/Services-Infos/Services8",
      icon: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9",
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      setIsSmallMobile(width <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth <= 1024;
  const isLargeMobile = windowWidth <= 640;

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.08, duration: 0.5, ease: [0.22, 1, 0.36, 1] }
    }),
    hover: !isMobile ? {
      y: -8,
      borderColor: '#C1A68D',
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)"
    } : {}
  };

  const imageVariants = {
    hover: !isMobile ? { scale: 1.05, transition: { duration: 0.6, ease: "easeOut" } } : {}
  };

  const truncateDescription = (text, maxLength) => {
    if (isSmallMobile) return text.length > maxLength * 0.7 ? text.substring(0, maxLength * 0.7) + "..." : text;
    if (isLargeMobile) return text.length > maxLength * 0.8 ? text.substring(0, maxLength * 0.8) + "..." : text;
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  return (
    <section style={styles.section}>
      {/* Texture de fond luxueuse */}
      <div style={styles.noiseOverlay}></div>

      {/* Lueur d'arrière plan */}
      <div style={styles.backgroundElements}>
        <div style={styles.glow1}></div>
        <div style={styles.glow2}></div>
      </div>

      {/* Section Header */}
      <motion.div
        style={styles.headerContainer}
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div
          style={{
            ...styles.badge,
            fontSize: isSmallMobile ? '0.75rem' : isMobile ? '0.8rem' : '0.85rem',
            padding: isSmallMobile ? '0.4rem 1rem' : '0.5rem 1.2rem',
          }}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          viewport={{ once: true }}
        >
          Pôles d'Intervention
        </motion.div>
        
        <motion.h2
          style={{
            ...styles.sectionTitle,
            fontSize: isSmallMobile ? '1.8rem' : isMobile ? '2.2rem' : 'clamp(2rem, 4vw, 3rem)',
            marginBottom: isSmallMobile ? '0.8rem' : '1rem',
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          viewport={{ once: true }}
        >
          Nos Domaines d'Expertise
        </motion.h2>
        
        <motion.p
          style={{
            ...styles.sectionSubtitle,
            fontSize: isSmallMobile ? '0.9rem' : isMobile ? '1rem' : '1.1rem',
            padding: isMobile ? '0 1rem' : '0',
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          viewport={{ once: true }}
        >
          Des solutions juridiques rigoureuses et sur mesure pour sécuriser vos opérations et accompagner votre réussite.
        </motion.p>
      </motion.div>

      {/* Services Grid */}
      <div style={{
        ...styles.grid,
        gridTemplateColumns: isSmallMobile 
          ? '1fr' 
          : isMobile 
            ? 'repeat(2, 1fr)' 
            : isTablet 
              ? 'repeat(3, 1fr)' 
              : 'repeat(4, 1fr)',
        gap: isSmallMobile ? '1rem' : isMobile ? '1.2rem' : '1.5rem',
        padding: isSmallMobile ? '0 1rem' : isMobile ? '0 1rem' : '0',
        marginBottom: isSmallMobile ? '3rem' : isMobile ? '4rem' : '5rem',
      }}>
        {services.map((service, index) => (
          <motion.div
            key={index}
            style={{
              ...styles.card,
              height: isSmallMobile ? 'auto' : isMobile ? '400px' : '440px',
              minHeight: isSmallMobile ? '380px' : isMobile ? '400px' : '440px',
            }}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            whileHover={!isMobile ? "hover" : undefined}
            custom={index}
            viewport={{ once: true, amount: 0.1 }}
            onMouseEnter={() => !isMobile && setHoveredCard(index)}
            onMouseLeave={() => !isMobile && setHoveredCard(null)}
          >
            <div style={styles.cardInner}>
              {/* Card Header with Image */}
              <Link to={service.lien} style={{ textDecoration: 'none', display: 'block' }}>
                <motion.div 
                  style={{
                    ...styles.imageContainer,
                    height: isSmallMobile ? '160px' : isMobile ? '160px' : '180px',
                  }}
                  variants={imageVariants}
                  whileHover={!isMobile ? "hover" : undefined}
                >
                  <div style={{ ...styles.gradientOverlay, background: premiumOverlay }} />
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    style={styles.image} 
                    loading="lazy"
                  />
                  <div style={styles.cardHeader}>
                    <div style={styles.iconContainer}>
                      <svg 
                        style={styles.icon} 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={service.icon} />
                      </svg>
                    </div>
                    <h3 style={{
                      ...styles.title,
                      fontSize: isSmallMobile ? '1.1rem' : isMobile ? '1.1rem' : '1.2rem',
                    }}>{service.title}</h3>
                  </div>
                </motion.div>
              </Link>

              {/* Card Content */}
              <div style={{
                ...styles.content,
                padding: isSmallMobile ? '1.2rem' : '1.5rem',
              }}>
                <div style={styles.keywords}>
                  {service.keywords.slice(0, 3).map((word, i) => (
                    <span key={i} style={styles.keyword}>
                      {word}
                    </span>
                  ))}
                </div>
                
                <p style={{
                  ...styles.description,
                  fontSize: isSmallMobile ? '0.85rem' : '0.9rem',
                  lineHeight: '1.6',
                  marginBottom: '1.5rem',
                  display: '-webkit-box',
                  WebkitLineClamp: isSmallMobile ? 3 : 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}>
                  {truncateDescription(service.description, 85)}
                </p>

                {/* CTA Button */}
                <motion.div style={styles.ctaContainer}>
                  <Link to={service.lien} style={{ textDecoration: 'none' }}>
                    <motion.button
                      style={styles.cta}
                      whileHover={!isMobile ? { backgroundColor: '#C1A68D', color: '#1A1A1A' } : {}}
                      whileTap={{ scale: 0.98 }}
                    >
                      <span style={styles.ctaText}>En savoir plus</span>
                      <svg style={styles.arrow} viewBox="0 0 24 24" fill="none">
                        <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </motion.button>
                  </Link>
                </motion.div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* View All & Stats Section */}
      <motion.div
        style={styles.viewAllContainer}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <div style={{
          ...styles.stats,
          gap: isSmallMobile ? '2rem' : isMobile ? '3rem' : '5rem',
          flexDirection: isSmallMobile ? 'column' : 'row',
          marginBottom: '3rem',
        }}>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>120+</span>
            <span style={styles.statLabel}>Dossiers traités</span>
          </div>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>100%</span>
            <span style={styles.statLabel}>Engagement Client</span>
          </div>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>24/7</span>
            <span style={styles.statLabel}>Disponibilité</span>
          </div>
        </div>

        <Link to="/services" style={{ textDecoration: 'none' }}>
          <motion.button
            style={styles.viewAllBtn}
            whileHover={!isMobile ? { scale: 1.02, backgroundColor: '#A88D73' } : {}}
            whileTap={{ scale: 0.98 }}
          >
            <span style={styles.viewAllText}>Consulter tous nos services</span>
            <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </motion.button>
        </Link>
      </motion.div>
    </section>
  );
};

const styles = {
  section: {
    padding: '6rem 0',
    background: '#0A0A0A',
    position: 'relative',
    overflow: 'hidden',
  },
  noiseOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundImage: "url('https://www.transparenttextures.com/patterns/stardust.png')",
    opacity: 0.15,
    mixBlendMode: 'overlay',
    pointerEvents: 'none',
    zIndex: 1,
  },
  backgroundElements: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    pointerEvents: 'none',
    zIndex: 0,
  },
  glow1: {
    position: 'absolute',
    width: '500px', height: '500px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(193, 166, 141, 0.05) 0%, transparent 70%)',
    top: '-15%', left: '-10%',
  },
  glow2: {
    position: 'absolute',
    width: '400px', height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(193, 166, 141, 0.04) 0%, transparent 70%)',
    bottom: '-10%', right: '-5%',
  },
  headerContainer: {
    textAlign: 'center',
    marginBottom: '4rem',
    position: 'relative',
    zIndex: 2,
  },
  badge: {
    display: 'inline-block',
    border: '1px solid #C1A68D',
    background: 'rgba(193, 166, 141, 0.05)',
    color: '#C1A68D',
    borderRadius: '4px',
    fontWeight: '500',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '1.2rem',
  },
  sectionTitle: {
    color: '#F5F0E6',
    fontWeight: '700',
    lineHeight: 1.2,
    margin: '0 auto',
    maxWidth: '90%',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
  },
  sectionSubtitle: {
    color: '#C1A68D',
    maxWidth: '650px',
    margin: '0 auto',
    lineHeight: 1.6,
    fontWeight: '300',
  },
  grid: {
    display: 'grid',
    maxWidth: '1400px',
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  },
  card: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '4px',
    background: 'rgba(26, 26, 26, 0.5)',
    border: '1px solid rgba(193, 166, 141, 0.15)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
  },
  cardInner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  imageContainer: {
    position: 'relative',
    overflow: 'hidden',
    borderBottom: '1px solid rgba(193, 166, 141, 0.1)',
  },
  gradientOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.8s ease',
    filter: 'grayscale(20%) contrast(110%)',
  },
  cardHeader: {
    position: 'absolute',
    bottom: 0, left: 0, right: 0,
    padding: '1.5rem 1.2rem',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  iconContainer: {
    background: 'rgba(26, 26, 26, 0.8)',
    border: '1px solid rgba(193, 166, 141, 0.3)',
    borderRadius: '4px',
    width: '36px', height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    width: '18px', height: '18px',
    color: '#C1A68D',
  },
  title: {
    color: '#F5F0E6',
    fontWeight: '600',
    margin: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  keywords: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginBottom: '1.2rem',
  },
  keyword: {
    background: 'transparent',
    color: '#C1A68D',
    border: '1px solid rgba(193, 166, 141, 0.3)',
    borderRadius: '2px',
    fontSize: '0.7rem',
    fontWeight: '500',
    padding: '4px 8px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  description: {
    color: '#D4C5B0',
    flex: 1,
    fontWeight: '300',
  },
  ctaContainer: {
    marginTop: 'auto',
  },
  cta: {
    width: '100%',
    background: 'transparent',
    border: '1px solid #C1A68D',
    color: '#C1A68D',
    borderRadius: '4px',
    padding: '0.8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  ctaText: {
    fontWeight: '500',
    fontSize: '0.85rem',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  arrow: {
    width: '16px', height: '16px',
  },
  viewAllContainer: {
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
    padding: '0 1rem',
  },
  stats: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  statItem: {
    textAlign: 'center',
  },
  statNumber: {
    display: 'block',
    fontWeight: '700',
    fontSize: '2.8rem',
    color: '#C1A68D',
    fontFamily: "'Times New Roman', serif",
    marginBottom: '0.3rem',
  },
  statLabel: {
    color: '#D4C5B0',
    fontWeight: '500',
    fontSize: '0.85rem',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  viewAllBtn: {
    background: '#C1A68D',
    color: '#1A1A1A',
    border: 'none',
    borderRadius: '4px',
    padding: '1rem 2.5rem',
    fontWeight: '600',
    fontSize: '0.95rem',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    transition: 'all 0.3s ease',
  },
  viewAllText: {
    fontWeight: '600',
  },
};

export default ServicesSection2;